import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

const ReturnExchangeButtons = ({ order, orderNo }) => {

    const navigate = useNavigate();

    const anyReturnable = useMemo(
        () => order?.order_items?.some(item => item.allow_return),
        [order]
    );

    const anyExchangeable = useMemo(
        () => order?.order_items?.some(item => item.allow_exchange),
        [order]
    );

    const exchangeItem = useMemo(
        () =>
            order?.order_items?.find(
                item => item.allow_exchange && item.valid_exchange_date
            ),
        [order]
    );

    if (!order?.order_items?.length) return null;

    return (
        <div className="button-box-desplay" style={{ padding: "6px 0 3px", borderTop: "1px solid #ddd" }}>

            {/* Exchange Valid Date */}
            {exchangeItem && (
                <p style={{ marginBottom: 0, color: "rgb(26 169 40)" }}>
                    Return / Exchange till{" "}
                    {new Date(exchangeItem.valid_exchange_date).toLocaleDateString(
                        "en-IN",
                        {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                        }
                    )}
                </p>
            )}

            <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>

                {/* RETURN */}
                {anyReturnable && (
                    <button
                        className="btn-defalt-exchange"
                        onClick={() =>
                            navigate(`/accounts/orders/${orderNo}/return`, {
                                state: {
                                    orderNo,
                                    selectOption: "return",
                                    item: order.order_items,
                                },
                            })
                        }
                    >
                        Return
                    </button>
                )}

                {/* EXCHANGE */}
                {anyExchangeable && (
                    <button
                        className="btn-defalt-exchange"
                        onClick={() =>
                            navigate(`/accounts/orders/${orderNo}/exchange`, {
                                state: {
                                    orderNo,
                                    selectOption: "exchange",
                                    item: order.order_items,
                                },
                            })
                        }
                    >
                        Exchange
                    </button>
                )}

            </div>
        </div>
    );
};

export default ReturnExchangeButtons;